import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { take } from 'rxjs/operators';
import { ApiError, ButtonLoader, MessageService, notCloseMessageOptions } from '../../../core';
import { TokenfieldComponent } from '../../../shared';
import { RichTextEditorComponent } from '../../../shared/components/rich-text-editor/rich-text-editor.component';
import { EmailService } from '../../common/email';
import { isOrcamento } from '../../configuracoes/app/pedido/tipo-venda';
import { PessoaContatoHttpService } from '../../pessoa/contato';
import { UsuarioEmailAdministrativoSelect, UsuarioEmailAdministrativoSelectComponent } from '../../usuario/email/administrativo/select';
import { PedidoOrcamentoEmailHttpService } from '../orcamentos/emails';
import { PedidoOrcamentoPrintRequestPayload, PedidoOrcamentoReportHttpService } from '../orcamentos/reports';
import { Pedido } from '../pedido';
import { PedidoReportService } from '../report';
import { PedidoCrudHttpService } from '../services';
import { PedidoEmailContato } from './pedido-email-contato';
import { PedidoEmailSendValueObject } from './pedido-email-send.valueobject';
import { PedidoEmailService } from './services';

interface Config {
    isOpen: boolean;
    isLoading: boolean;
}

@Component({
    selector: 'sgt-pedido-email-modal',
    templateUrl: './pedido-email-modal.component.html',
    styleUrls: ['./pedido-email-modal.component.less']
})
export class PedidoEmailModalComponent implements OnInit {
    config: Config;
    idPedido: number;
    entity: Pedido;
    valueObject = new PedidoEmailSendValueObject(null);
    contatosTo: PedidoEmailContato[];

    @Input() idModal: string;
    elModal: any;

    /** Evento após enviar o e-mail */
    @Output() afterSend = new EventEmitter<void>();
    /** Evento após cancelar o envio do e-mail */
    @Output() afterCancel = new EventEmitter<void>();

    @ViewChild('form') form: NgForm;
    @ViewChild('toTokenfield') toTokenfield:  TokenfieldComponent;
    @ViewChild('richTextEditorRef') richTextEditorRef: RichTextEditorComponent;
    @ViewChild('subjectInput') subjectInput: ElementRef;
    @ViewChild('usuarioEmailAdministrativoSelect') usuarioEmailAdministrativoSelect: UsuarioEmailAdministrativoSelectComponent;


    constructor(private el: ElementRef,
                private pedidoEmailService: PedidoEmailService,
                private messageService: MessageService,
                private emailService: EmailService,
                private pessoaContatoHttpService: PessoaContatoHttpService,
                private pedidoCrudHttpService: PedidoCrudHttpService,
                private pedidoReportService: PedidoReportService,
                private pedidoOrcamentoReportHttpService: PedidoOrcamentoReportHttpService,
                private pedidoOrcamentoEmailHttpService: PedidoOrcamentoEmailHttpService) { }

    ngOnInit() {
        this.createConfig();
        this.create();
    }

    /** Cria a config do form */
    private createConfig() {
        this.config = {
            isOpen: false,
            isLoading: false
        };
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.config.isOpen = true;
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.afterOpen();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.config.isOpen = false;
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    /** Carrega o pedido/orçamento para solicitar a sua revisão */
    private findPedidoOrcamento(idPedidoOrcamento: number): Promise<Pedido> {
        return new Promise<Pedido>((resolve, reject) => {
            this.config.isLoading = true;
            this.pedidoCrudHttpService.find(idPedidoOrcamento)
                .pipe(take(1))
                .subscribe(
                    pedidoOrcamento => resolve(pedidoOrcamento),
                    (error: ApiError) => reject(error),
                    () => this.config.isLoading = false
                );
        });
    }

    open(idPedido: number) {
        this.idPedido = idPedido;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Após abrir a modal */
    private async afterOpen() {
        try {
            // Carregando pedido
            this.entity = await this.findPedidoOrcamento(this.idPedido);
            // Criando o Value Object
            this.valueObject = new PedidoEmailSendValueObject(this.idPedido);
            // Obtendo os dados para o e-mail do pedido
            this.pedidoEmailService.create(this.idPedido)
                .subscribe(
                    email => {
                        // this.email.to = email.to;
                        this.valueObject.cc = email.cc;
                        this.valueObject.subject = email.subject;
                        this.valueObject.message = this.emailService.createAssinaturaEmail(email.urlAssinaturaEmail);
                    },
                    (error: ApiError) => this.messageService.error(error.message, 'Erro ao criar o e-mail do pedido', error)
                );

            setTimeout(() => {
                // Setando focus
                this.toTokenfield.setFocus();
                // Removendo quais atributos disabled e readonly dos campos no form do e-mail, pois, quando abrir o modal dentro de um pedido bloqueado os campos do modal ficavam bloqueados também.
                this.elModal.find('.form-control').removeAttr('disabled', 'disabled').removeAttr('readonly', 'readonly');
                // Criando os contatos através dos contatos do cliente do pedido
                this.criarContatosTo(this.entity.idPessoa);
                // Criando os e-mails administrativos
                this.usuarioEmailAdministrativoSelect.create();
            }, 100);
        } catch (error) {
            this.messageService.error(error.message, 'Erro ao tentar abrir a janela para enviar um novo e-mail', error);
        }
    }

    /** Limpas as variáveis utilizadas no modal */
    private clear() {
        this.idPedido = null;
        this.entity = null;
        this.valueObject = null;
        this.contatosTo = null;
    }

    private close() {
        this.elModal.modal('hide');
    }

    /** Envia o e-mail do orçamento */
    private sendOrcamento(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
          this.valueObject.message = this.richTextEditorRef.getContent();
            this.pedidoOrcamentoEmailHttpService.send(this.valueObject)
                .pipe(take(1))
                .subscribe(
                    response => {
                        this.messageService.success('', response);
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        reject(error);
                    }
                );
        });
    }

    /** Envia o e-mail do pedido */
    private sendPedido(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
          this.valueObject.message = this.richTextEditorRef.getContent();
            this.pedidoEmailService.send(this.valueObject)
                .pipe(take(1))
                .subscribe(
                    response => {
                        this.messageService.success('', response);
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        reject(error);
                    }
                );
        });
    }

    /** Envia o e-mail do pedido */
    async send() {
        try {
            // Validando
            if (!this.valueObject.isValid()) {
                // Exibindo mensagem de dado inválido
                this.messageService.warning(this.valueObject.messageError, 'Atenção', notCloseMessageOptions);
                // Setando foco no input inválido
                switch (this.valueObject.propError) {
                    case 'to':
                        this.toTokenfield?.setFocus();
                        break;
                    case 'subject':
                        jQuery(this.subjectInput?.nativeElement).trigger('focus');
                        break;
                    default:
                        break;
                }

                return;
            }

            const btnSendPedido = new ButtonLoader('#btnSendPedido');
            btnSendPedido.loading('Enviando');

            if (isOrcamento(this.entity.tipoVenda)) { // Orçamento
                await this.sendOrcamento();
            } else { // Pedido
                await this.sendPedido();
            }

            btnSendPedido.reset();
            this.afterSend.emit();
            this.close();
        } catch (error) {
            this.messageService.error(error.mensagem, 'Erro ao tentar enviar o e-mail', error);
        }
    }

    async print() {
        if (isOrcamento(this.entity.tipoVenda)) { // Orçamento
            const valueObject = new PedidoOrcamentoPrintRequestPayload(this.entity.id);
            if (!valueObject.isValid()) {
                this.messageService.warning(valueObject.messageError, 'Atenção', notCloseMessageOptions);
                return false;
            }
            await this.pedidoOrcamentoReportHttpService.print(valueObject);
        } else { // Pedido
            this.pedidoReportService.print(this.entity.id);
        }
    }

    /** Cria os contatos da pessoa do pedido para a seleção no campo "Para"  */
    private criarContatosTo(idPessoa: number) {
        this.contatosTo = [];
        this.pessoaContatoHttpService.searchContatos(idPessoa)
            .subscribe(
                entities => {
                    if (entities) {
                        entities.forEach(entity => {
                            // Somente adicionamos contatos com e-mail informado
                            if (entity.email && entity.email.trim().length > 0) {
                                const contato = new PedidoEmailContato(entity.nome, entity.email);
                                this.contatosTo.push(contato);
                            }
                        })
                    }
                },
                (error: ApiError) => this.messageService.error('Erro ao obter os contatos cadastrados no cliente. Tente abrir a janela do e-mail novamente', 'Ocorreu um erro', error.message)
            );
    }

    /** Adiciona ou remove algum e-mail do campo "Para" */
    toggleContatoTo(contato: PedidoEmailContato) {
        if (!contato.adicionado) {
            this.toTokenfield.createToken(contato.email);
            contato.adicionado = true;
        } else {
            this.toTokenfield.removeToken(contato.email);
            contato.adicionado = false;
        }
    }

    /** Ao adicionar um e-mail no campo "Para" */
    onCreateContatoTo(email: string) {
        const contato = this.getContatoToByEmail(email);
        if (contato) {
            contato.adicionado = true;
        }
    }

    /** Ao remover um e-mail no campo "Para" */
    onRemoveContatoTo(email: string) {
        const contato = this.getContatoToByEmail(email);
        if (contato) {
            contato.adicionado = false;
        }
    }

    /** Obtem o contato do e-mail nos contatos da pessoa do pedido */
    private getContatoToByEmail(email: string): PedidoEmailContato {
        return this.contatosTo.find(contato => contato.email === email);
    }

    /** Ao selecionar ou não um e-mail administrativo do usuário */
    onToggleSelectUsuarioEmailAdministrativo(usuarioEmailAdministrativoSelect: UsuarioEmailAdministrativoSelect) {
        if (!usuarioEmailAdministrativoSelect) {
            return;
        }

        if (usuarioEmailAdministrativoSelect.selected) { // Selecionado
            this.toTokenfield.createToken(usuarioEmailAdministrativoSelect.email);
        } else { // Não selecionado
            this.toTokenfield.removeToken(usuarioEmailAdministrativoSelect.email);
        }
    }

    /** Cancela o envio do e-mail e fecha a modal */
    cancel() {
        this.afterCancel.emit();
        this.close();
    }
}
